document.addEventListener('DOMContentLoaded', function () {
  const addonsWrapper = document.querySelector('.product-machine-addons');
  if (!addonsWrapper) return;
  const basePrice = parseInt(addonsWrapper.dataset.basePrice, 10);
  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify.currency.active || 'SGD' });
  }
  function updateTotal() {
    let total = basePrice;
    addonsWrapper.querySelectorAll('.addon-checkbox:checked').forEach(cb => {
      total += parseInt(cb.dataset.price, 10);
    });
    const priceEl = document.querySelector('[id^="price"]');
    if (priceEl) priceEl.textContent = formatMoney(total);
  }
  addonsWrapper.querySelectorAll('.addon-checkbox').forEach(cb => {
    cb.addEventListener('change', updateTotal);
  });

  // --- NEW: info icon tooltip toggle ---
  const infoIcon = document.querySelector('.addon-info-icon');
  const infoTooltip = document.querySelector('.addon-info-tooltip');

  if (infoIcon && infoTooltip) {
    infoIcon.addEventListener('click', function (e) {
      e.stopPropagation();
      const isVisible = infoTooltip.classList.toggle('is-visible');
      infoIcon.setAttribute('aria-expanded', isVisible);
    });

    document.addEventListener('click', function (e) {
      if (!infoTooltip.contains(e.target) && e.target !== infoIcon) {
        infoTooltip.classList.remove('is-visible');
        infoIcon.setAttribute('aria-expanded', 'false');
      }
    });
  }
  // --- END NEW ---

  addonsWrapper.querySelectorAll('.addon-variant-select').forEach(sel => {
    sel.addEventListener('change', function () {
      const opt = this.selectedOptions[0];
      const wrapper = this.closest('.addon-item');
      const checkbox = wrapper.querySelector('.addon-checkbox');
      checkbox.dataset.variantId = opt.value;
      checkbox.dataset.price = opt.dataset.price;
      wrapper.querySelector('.addon-price').textContent = formatMoney(parseInt(opt.dataset.price, 10));
      wrapper.querySelector('.addon-thumb').src = opt.dataset.image;
      updateTotal();
    });
  });
  // Called by the PDP submit handler after the main item is added: a parallel /cart/add raced it and dropped one
  window.addMachineAddons = function () {
    const items = Array.from(addonsWrapper.querySelectorAll('.addon-checkbox:checked')).map(cb => ({
      id: parseInt(cb.dataset.variantId, 10),
      quantity: 1
    }));
    if (!items.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    }).catch(err => console.error('Add-on cart add failed', err));
  };
});
